import React, { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import Countdown from "react-countdown";

const ExpiryCountdown = ({ indent }) => {
  const isPmIndent = indent?.indent_type === "private_market_place_indent";

  const timestamp =
    indent?.expiry_date ?? indent?.summary?.[0]?.reject_expiry_time;

  if (
    !timestamp ||
    isPmIndent ||
    indent?.allocation_status?.allocated === 1 ||
    indent?.is_delete
  ) {
    return null;
  }

  const deadline = new Date(timestamp);

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return null;
    }

    if (days > 0) {
      return `${days}d:${hours}h:${minutes}m`;
    } else if (hours === 0) {
      return `${minutes}m:${seconds}s`;
    } else {
      return `${hours}h:${minutes}m:${seconds}s`;
    }
  };

  return (
    <div className="text-danger font-weight-bold">
      {!isPmIndent ? (
        <>
          <div
            data-tip
            data-for="countdown"
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "5px" }}
          >
            <Countdown date={deadline} renderer={renderer} />
          </div>

          <ReactTooltip id="countdown" effect="float" place="bottom">
            Expiry time
          </ReactTooltip>
        </>
      ) : null}
    </div>
  );
};

export default ExpiryCountdown;
